<template>
  <div class="col px-0 d-flex content-detail">
    <staff-list
      class="col-3 d-flex flex-column"
      :selectedTab="selectedStatus"
      :staffs="staffList"
      @create:staff="loadStaffList()"
    />
    <staff-edit
      class="col-9 d-flex flex-column"
      :staff="staff"
      :roles="roles"
      :financialInstitutions="financialInstitutions"
      v-if="staff"
      @update:staff="loadAll(adminId)"
    />
    <staff-create
      class="col-9 d-flex flex-column"
      :roles="roles"
      :financialInstitutions="financialInstitutions"
      v-else
    />
  </div>
</template>

<script>
import axios from "axios";
import StaffList from "./StaffList";
import StaffEdit from "./StaffEdit";
import StaffCreate from "./StaffCreate";
import { getCookie, Auth } from "@/lib/cookie";

export default {
  components: {
    StaffList,
    StaffEdit,
    StaffCreate
  },
  data() {
    return {
      staff: null,
      staffList: [],
      histories: null,
      roles: null,
      financialInstitutions: null,
      adminId: this.$route.params.adminId,
      selectedStatus: "active"
    };
  },
  created() {
    if (this.adminId) {
      this.loadAll(this.adminId);
    }

    if (this.staffList && this.staffList.length < 1) {
      this.loadStaffList();
    }

    if (!this.roles) {
      this.loadStaffRoles();
    }

    if (!this.financialInstitutions) {
      this.loadFinancialInstitutionList();
    }
  },
  watch: {
    $route(to) {
      if (to.params.adminId) {
        this.adminId = to.params.adminId;
        this.loadAll(to.params.adminId);
      } else {
        this.staff = null;
        this.$store.state.currentStaffName = null;
        this.$router.push({
          name: "StaffCreate"
        });
      }
    }
  },
  methods: {
    async loadAll(adminId) {
      const staff = this.loadStaff(adminId);
      const staffs = this.loadStaffList();

      await Promise.all([staff, staffs]);
    },
    async loadStaff(adminId) {
      const result = await axios.get(
        `${process.env.HOST}/admin/staffs/${adminId}`,
        {
          headers: {
            Authorization: `Bearer ${getCookie(Auth.AccessToken)}`
          }
        }
      )

      const staffDetail = result.data;

      this.staff = {
        ...staffDetail,
        provider: staffDetail.providerId
          ? { id: staffDetail.providerId.toString() }
          : null
      }
  
      this.selectedStatus = this.staff.isActive ? "active" : "inactive";

      const staffName = this.staff.firstName + " " + this.staff.lastName;
      this.$parent.$emit("change:staff", staffName);
      this.$store.state.currentStaffName = staffName;
    },
    async loadStaffRoles() {
      const result = await axios.get(`${process.env.HOST}/admin/staffs/roles`, {
        headers: {
          Authorization: `Bearer ${getCookie(Auth.AccessToken)}`
        }
      });

      this.roles = result.data;
    },
    async loadStaffList() {
      try {
        const result = await axios.get(`${process.env.HOST}/admin/staffs`, {
          headers: {
            Authorization: `Bearer ${getCookie(Auth.AccessToken)}`
          }
        });

        this.staffList = result.data;
      } catch (e) {
        alert("Could not load staff list");
        throw e;
      }
    },
    async loadFinancialInstitutionList() {
      try {
        const response = await axios.get(`${process.env.HOST}/api/admin/financial_institutions`, {
          headers: {
            Authorization: `Bearer ${getCookie(Auth.AccessToken)}`
          }
        });

        this.financialInstitutions = response.data.result;
      } catch (e) {
        alert("Could not load financial institution list");
        throw e;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.content-detail {
  height: calc(100vh - 110px);
}
</style>



// WEBPACK FOOTER //
// src/components/admin/view/staff/Staff.vue